import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName,} from "../Univ";
import "bootstrap/dist/css/bootstrap.min.css";
export default function Warehouse() {
    const [loading, setLoading] = useState(false);
    const [owners, setOwners] = useState([]);
    const [warehouseList, setWarehouseList] = useState([]);
    const [editId, setEditId] = useState(null);
    const [formData, setFormData] = useState({
        owner: "",
        warehouse_name: "",
        warehouse_code: "",
        address: "",
        location: "",
        capacity: "",
        capacity_unit: "TON",
        manager_name: "",
        mobile: "",
        status: 1,
        addedby: userName,
        ip_add: ipAddress,
    });
    const capacityUnitList = [{id: "TON", name: "TON"}, {id: "KG", name: "KG"}, {id: "BAG", name: "BAG"}, {
        id: "LITER",
        name: "LITER"
    },];
    useEffect(() => {
        getWarehouse();
        fetchOwners();
    }, []);
    const getWarehouse = () => {
        setLoading(true);
        axios
            .get(baseUrl + "warehouse/")
            .then((res) => {
                setWarehouseList(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                Swal.fire({
                    icon: "error", title: "Error", text: "Unable to load warehouse records.",
                });
            });
    };
     // ===========================================
    // FETCH OWNERS
    // ===========================================
    const fetchOwners = async () => {
        try {
            const res = await axios.get(baseUrl + "land-owner/create/");
            setOwners(res.data);
        } catch (error) {
            console.log(error);
        }
    };
    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData({
            ...formData, [name]: value,
        });
    };
    const clearForm = () => {
        setFormData({
            warehouse_name: "",
            warehouse_code: "",
            address: "",
            location: "",
            capacity: "",
            capacity_unit: "TON",
            manager_name: "",
            mobile: "",
            status: 1,
            addedby: userName,
            ip_add: ipAddress,
        });
    };
    const saveWarehouse = () => {

    const data = new FormData();

    data.append("owner", formData.owner);
    data.append("warehouse_name", formData.warehouse_name);
    data.append("warehouse_code", formData.warehouse_code);
    data.append("address", formData.address);
    data.append("location", formData.location);
    data.append("capacity", formData.capacity);
    data.append("capacity_unit", formData.capacity_unit);
    data.append("manager_name", formData.manager_name);
    data.append("mobile", formData.mobile);
    data.append("status", formData.status);
    data.append("addedby", userName);
    data.append("ip_add", ipAddress);

    setLoading(true);

    const request =
        editId === null
            ? axios.post(baseUrl + "warehouse/", data)
            : axios.put(baseUrl + `update-warehouse/${editId}/`, data);

    request
        .then(() => {

            Swal.fire({
                icon: "success",
                title: "Success",
                text: editId === null
                    ? "Warehouse saved successfully."
                    : "Warehouse updated successfully.",
            });

            clearForm();
            getWarehouse();
            setLoading(false);

        })
        .catch(() => {

            setLoading(false);

            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Unable to save warehouse.",
            });

        });

};
   const editData = async (row) => {

    setEditId(row.id);

    const res = await axios.get(
        baseUrl + `update-warehouse/${row.id}/`
    );

    const data = res.data;

    setFormData({
        owner: data.owner.id,
        warehouse_name: data.warehouse_name,
        warehouse_code: data.warehouse_code,
        address: data.address,
        location: data.location,
        capacity: data.capacity,
        capacity_unit: data.capacity_unit,
        manager_name: data.manager_name,
        mobile: data.mobile,
        status: data.status,
    });

};
    const deleteWarehouse = (id) => {
        Swal.fire({
            title: "Delete Warehouse?",
            text: "You won't be able to revert this.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios
                    .delete(baseUrl + `delete-warehouse/${id}/`)
                    .then(() => {
                        Swal.fire({
                            icon: "success", title: "Deleted", text: "Warehouse deleted successfully.",
                        });
                        getWarehouse();
                    })
                    .catch(() => {
                        setLoading(false);
                        Swal.fire({
                            icon: "error", title: "Error", text: "Unable to delete warehouse.",
                        });
                    });
            }
        });
    };
    const columns = [{
        field: "id", headerName: "ID", width: 80,
    }, {
        field: "warehouse_name", headerName: "Warehouse", flex: 1,
    }, {
        field: "warehouse_code", headerName: "Code", width: 120,
    }, {
        field: "location", headerName: "Location", width: 180,
    }, {
        field: "capacity", headerName: "Capacity", width: 120,
    }, {
        field: "capacity_unit", headerName: "Unit", width: 100,
    }, {
        field: "manager_name", headerName: "Manager", width: 180,
    }, {
        field: "mobile", headerName: "Mobile", width: 150,
    }, {
        field: "status",
        headerName: "Status",
        width: 100,
        renderCell: (params) => params.value === 1 ? "Active" : "Inactive",
    },
    {
    field: "action",
    headerName: "Action",
    width: 180,
    sortable: false,
    renderCell: (params) => (
        <>
            <button
                className="btn btn-success btn-sm me-2"
                onClick={() => editData(params.row)}
            >
                Edit
            </button>

            <button
                className="btn btn-danger btn-sm"
                onClick={() => deleteWarehouse(params.row.id)}
            >
                Delete
            </button>
        </>
    ),
},
    ];
    return (<div className="container-fluid mt-3">

        <div className="card shadow">

            <div className="card-header bg-primary text-white">
                <h5 className="mb-0">Warehouse Master</h5>
            </div>

            <div className="card-body">

                <div className="row">

                    <div className="col-md-4 mb-3">
                        <label>Warehouse Name</label>
                        <input
                            type="text"
                            className="form-control"
                            name="warehouse_name"
                            value={formData.warehouse_name}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="col-md-4 mb-3">
                        <label>Warehouse Code</label>
                        <input
                            type="text"
                            className="form-control"
                            name="warehouse_code"
                            value={formData.warehouse_code}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="col-md-4 mb-3">
                        <label>Location</label>
                        <input
                            type="text"
                            className="form-control"
                            name="location"
                            value={formData.location}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="col-md-6 mb-3">
                        <label>Address</label>
                        <textarea
                            className="form-control"
                            rows="3"
                            name="address"
                            value={formData.address}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="col-md-2 mb-3">
                        <label>Capacity</label>
                        <input
                            type="number"
                            className="form-control"
                            name="capacity"
                            value={formData.capacity}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="col-md-2 mb-3">
                        <label>Unit</label>
                        <select
                            className="form-select"
                            name="capacity_unit"
                            value={formData.capacity_unit}
                            onChange={handleChange}
                        >
                            {capacityUnitList.map((item) => (<option key={item.id} value={item.id}>
                                {item.name}
                            </option>))}
                        </select>
                    </div>

                    <div className="col-md-2 mb-3">
                        <label>Status</label>
                        <select
                            className="form-select"
                            name="status"
                            value={formData.status}
                            onChange={handleChange}
                        >
                            <option value={1}>Active</option>
                            <option value={0}>Inactive</option>
                        </select>
                    </div>
                                              <div className="col-md-4 mb-3">

                                    <label className="form-label">

                                        Land Owner

                                    </label>

                                    <select

                                        className="form-select"

                                        name="owner"

                                        value={formData.owner}

                                        onChange={handleChange}

                                    >

                                        <option value="">

                                            Select Owner

                                        </option>

                                        {
                                            owners.map(owner => (
                                                <option

                                                    key={owner.id}

                                                    value={owner.id}

                                                >

                                                    {owner.name}

                                                </option>
                                            ))
                                        }

                                    </select>

                                </div>

                    <div className="col-md-4 mb-3">
                        <label>Manager Name</label>
                        <input
                            type="text"
                            className="form-control"
                            name="manager_name"
                            value={formData.manager_name}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="col-md-4 mb-3">
                        <label>Mobile</label>
                        <input
                            type="text"
                            className="form-control"
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="col-md-4 d-flex align-items-end mb-3">

                        <button
                            className="btn btn-success me-2"
                            onClick={saveWarehouse}
                            disabled={loading}
                        >
                            Save
                        </button>

                        <button
                            className="btn btn-secondary"
                            onClick={clearForm}
                        >
                            Clear
                        </button>

                    </div>

                </div>
                <hr/>

                <div style={{height: 550, width: "100%"}}>

                    <ERPDataGrid
                        rows={warehouseList}
                        columns={columns}
                        loading={loading}
                        getRowId={(row) => row.id}
                       
                        pageSizeOptions={[10, 25, 50, 100]}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    page: 0, pageSize: 10,
                                },
                            },
                        }}
                    />

                </div>

            </div>

        </div>

    </div>);
}